import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

import {Store, BrandliftStore, BrandliftStatsStore} from 'client/common/types';

import {QuicksurveyContext, BrandliftContext} from 'client/common/store/reducers/context/types';
import {getSurvey} from 'client/common/store/selectors/survey';

import {genPreviewData, PreviewData} from 'client/common/utils/generate-preview-data';
import {Metric} from 'client/common/types/brandlift/types';
import {METRIC_QUESTION_ORDER} from 'client/common/types/brandlift/consts';

export function getContext(state: BrandliftStore | BrandliftStatsStore): BrandliftContext;
export function getContext(state: Store): QuicksurveyContext;
export function getContext(state: Store) {
    return cloneDeep(state.context);
}

export function getIsBrandliftContextChanged(state: Store) {
    const survey = getSurvey(state);
    const formContext = getContext(state);
    const {context: surveyContext} = survey;

    if (!surveyContext || isEmpty(surveyContext)) {
        return true;
    }

    return Object.keys(surveyContext).some(
        (key: keyof QuicksurveyContext) => !isEqual(formContext[key], surveyContext[key])
    );
}

export function getMetricList({customMetrics}: BrandliftContext): Metric[] {
    return customMetrics || [];
}

export function sortMetricList(metricList: Metric[]) {
    return metricList.sort(
        (a, b) => METRIC_QUESTION_ORDER.indexOf(a) - METRIC_QUESTION_ORDER.indexOf(b)
    );
}

export function getPreviewData(state: BrandliftStore): PreviewData[] {
    const context = getContext(state);
    const metricList = getMetricList(context);

    const sortedMetricList = sortMetricList(metricList);

    return genPreviewData(sortedMetricList, context);
}

export function getLogoUploaderState(state: BrandliftStore): boolean {
    const context = getContext(state);

    return Boolean(context?.logos.length);
}
